import React, { Component } from 'react';
import ResetPasswordComponent from '../components/resetPasswordComponents';
import { ResetUserPassword ,ResetUserPasswordRequest,ResetUserPasswordRequest12,ResetUserPassword12,FetchUserPasswordRequest12} from '../actions/resetPasswordAction'
import {getCompanyBrandingList} from '../actions/forgotPasswordAction'
import { loggedIn, logOutUser, getProfile, logout } from '../../Login/actions/loginAction'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { useParams } from 'react-router-dom';
class ResetPasswordContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: ""
        }
         this.props.actions.getCompanyBrandingList();
        logout();
        this.props.actions.logOutUser();
        this.ResetPassword1 = this.ResetPassword1.bind(this)
    }

    componentWillMount() {
         this.props.actions.getCompanyBrandingList(this.props.dispatch);
          this.props.actions.FetchUserPasswordRequest12(
                     this.props.dispatch
                 )
    }
ResetPassword1(username) {
        this.props.actions.ResetUserPassword12(
            username,           
            this.props.dispatch)
    }
    ResetPassword=(data)=> {
        this.props.actions.ResetUserPassword(
            data,           
            this.props.dispatch).then((res)=>{
                if(res.statusCode==200)
                {
                    setTimeout(()=>{
                            this.props.history.push('/login'); 
                    },2000)
                }
            })
    }

   

    render() {
         const  userId  = window.location.pathname;
        return (
                <div> 
                    <ResetPasswordComponent 
                    UserId={userId}
                        ResetPassword={this.ResetPassword}
                        ResetPassword1={this.ResetPassword1}  
                        resetPassword={this.props.resetPassword}
                    />
                   
                </div>
            )

    }

}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            ResetUserPassword,ResetUserPasswordRequest12,ResetUserPassword12,FetchUserPasswordRequest12, 
            logOutUser,getCompanyBrandingList,
            ResetUserPasswordRequest,
        },
            dispatch)
    };
}

function mapStateToProps({ resetPasswordReducer}) {
    console.log(resetPasswordReducer)
    return {
        
         resetPassword:{
            isLoading: resetPasswordReducer.isLoading, 
            statusCode:resetPasswordReducer.statusCode,
            errorMessage:resetPasswordReducer.errorMessage,
            brandList: resetPasswordReducer.brandList,
            otpstatusCode:resetPasswordReducer.otpstatusCode
         }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer))
